const AUTOMATION_EMPTY_REQUESTS_PAGE_TEXT = 'AUTOMATION_EMPTY_REQUESTS_PAGE_TEXT';
const AUTOMATION_SP_BEST_MATCHES_LIST = 'AUTOMATION_SP_BEST_MATCHES_LIST';

export { AUTOMATION_SP_BEST_MATCHES_LIST, AUTOMATION_EMPTY_REQUESTS_PAGE_TEXT };
